<template>
  <div class="app-container withdraw">
    <div class="filter">
      <div
        style="font-weight:bold;font-family:'PingFang SC';font-size:14px;min-width: 450px;"
      >
        <span style="margin-right: 40px;">消费合计：￥{{ consumeNumber }}</span>
        <span>分佣合计：￥{{ bonusNumber }}</span>
      </div>

      <el-input
        v-model="listQuery.invitation_code"
        placeholder="用户编号"
        :clearable="true"
        style="width: 200px;margin: 0px 10px;margin-left: auto;"
      ></el-input>

      <span
        style="font-weight:bold;font-family:'PingFang SC';font-size:14px;margin-left: 20px;text-wrap: nowrap;"
        >消费时间:</span
      >
      <el-date-picker
        v-model="listQuery.start_at"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择开始时间"
        style="margin-right: 10px;"
      ></el-date-picker>
      <span style="font-weight:bold;font-family:'PingFang SC';font-size:14px;"
        >到</span
      >

      <el-date-picker
        v-model="listQuery.end_at"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="请选择结束时间"
      ></el-date-picker>

      <el-button type="primary" size="medium" @click="searchHandler"
        >搜索</el-button
      >
    </div>
    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>

      <el-table-column label="用户编号" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.buyer_user.invitation_code
        }}</template>
      </el-table-column>
      <el-table-column label="用户昵称" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.buyer_user.nickname
        }}</template>
      </el-table-column>

      <el-table-column label="购买产品" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.productName }}</template>
      </el-table-column>

      <el-table-column label="消费金额" align="center" min-width="95">
        <template slot-scope="scope">￥{{ (scope.row.bonus / scope.row.ratio).toFixed(2)}}</template>
      </el-table-column>

      <el-table-column label="获得分佣" align="center" min-width="110">
        <template slot-scope="scope">￥{{ scope.row.bonus }}</template>
      </el-table-column>

      <el-table-column label="消费时间" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.created_at }}</template>
      </el-table-column>
    </el-table>

    <div
      class="pagination"
      style="display: flex;align-items: center;justify-content: center;margin-top: 15px;"
    >
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// 分销明细
import {getAgentList} from "@/api/distribution";

export default {
  data() {
    return {
      consumeNumber: "0", //消费记录
      bonusNumber: "0", //分佣
      formInline: {},
      listLoading: false,
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        start_at: "",
        end_at: "",

        invitation_code: ""
      },
      list: []
    };
  },
  mounted() {
    this.getList();
    // console.log(this.$store.state.user.username)
  },
  methods: {
    // 搜索
    searchHandler() {
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      this.listQuery.start_at = this.listQuery.start_at
        ? this.listQuery.start_at + " 00:00:00"
        : "";
      this.listQuery.end_at = this.listQuery.end_at
        ? this.listQuery.end_at + " 23:59:59"
        : "";
      getAgentList(this.listQuery)
        .then(result => {
          this.consumeNumber = result.data.consumeNumber;
          this.bonusNumber = result.data.bonusNumber;
          this.list = result.data.data.data;
          this.total = result.data.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(err => {
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.filter {
  margin: 10px 0;
  display: flex;
  align-items: center;
}
.filter > * {
  margin-right: 10px;
}
</style>
